var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container"},[_c('div',[_c('header-checkout')],1),_c('div',{staticClass:"app-content d-flex flex-column",class:_vm.isMobile ? '' : 'app-slim-scroll',attrs:{"id":"app-layout-content"}},[_vm._t("default"),_c('app-footer',{staticStyle:{"margin-top":"auto"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }